/*
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-17 17:38:53
 * @Description:
 */
import type {
    BetDetailsReponseStateType,
    BetHistoryReponseStateType,
} from '@/socket/gamehistory/dto/gameHistory.dto';
import {fixHistoryData} from '@/socket/game';

export const useGameHistorySocket = () => {
    const rootPath = 'gamehistory';
    // ↓查询玩家在某个游戏下的“多条” 历史记录
    const EMIT_GET_HISTORY = (
        data: any,
        callback: (res: BetHistoryReponseStateType) => any,
    ) => {
        // ↓ 转为字符提升健壮性（防止收到非字符导致报错
        data.game = String(data.game);
        socket.emit(
            `${rootPath}.getHistory`,
            data,
            (arr)=>{
                fixHistoryData(arr.response);
                callback(arr);
            },
        );
    };

    // ↓ 查询玩家某一局游戏的历史记录
    // ↓ 入参 1 的格式示例：{id: 'mines:1604'} ◆ {id: `${getGameApi()}:${dataId}`} 
    const EMIT_BET_DETAILS = (
        data: any, 
        callback: (res: BetDetailsReponseStateType) => any,
    ) => {
        socket.emit(`${rootPath}.betDetails`, data, callback);
    };

    // ↓ 建立监听，用于接收下一局的 hash 值，和 jackpot 信息
    // ↓ 在一局游戏的结束后，会收到数据 
    const ON_GAMES_INFO = (game, callback) => {
        // ↓ 后端推送值示例 
        // 42["games.dice.info",{"jackpot":0}]	
        // 42["games.dice.info",{"hash":"8f80ae7561d058c71301fe05717b158d8eeea2557b25f72d10c9f67efe92a22f"}]	
        // 42["games.plinko.info",{"jackpot":[0,1,1,1,1,0]}]	
        // 42["games.plinko.info",{"hash":"f1757bc16ee8b2731515098cc5cf86b2f51a7184c5273a9c10f0b2e8664d8cfe"}]	 
        
        const sApi = `games.${game}.info`;
        socket.on(sApi, callback);
        return ()=>{
            socket.off(sApi, callback);
        }
    }
    return {
        EMIT_GET_HISTORY,
        EMIT_BET_DETAILS,
        ON_GAMES_INFO,
    };
};

